import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import MainNavigation from "../../components/navigation/MainNavigation";
import ChannelOptimalisationModal from "../../components/modals/EditBrandModal/submodals/ChannelOptimalisationModal";
import "./Current.scss";

const ChannelOptimalisation = () => {
  const currentBrand = useSelector((state: any) => state.currentBrand.data);
  const brandId = currentBrand?.domain;
  const brandName = currentBrand?.brandName;

  useEffect(() => {
    document.title = "Channel Optimisation - Benchmarks - Smartocto real-time";
    document.body.dataset.titleReady = "true";
  }, []);

  return (
    <>
      <MainNavigation />
      <div className="page-container-no-side-nav">
        <div className="channel-optimisation-page">
          {brandId && (
            <ChannelOptimalisationModal
              key={brandId}
              brandId={brandId}
              brandName={brandName}
              onClose={() => {}}
              hideActions={true}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ChannelOptimalisation;